<template>
  <div>
    <v-btn color="primary" small @click="check5GOrder">Submit 5G</v-btn>
    <v-btn color="primary" small @click="setOrderItem()">SOG Order</v-btn>
    <prompt-dialog
      :text="message"
      :dialog="dialog"
      @submitOrder="process5GOrder"
      @closePrompt="dialog = false"
    ></prompt-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import PromptDialog from '@/components/dialogs/PromptDialog';
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapAddressActions } =
  createNamespacedHelpers(`orders/address`);

export default Vue.extend({
  components: {
    PromptDialog,
  },
  data: () => ({
    message: 'Are you sure you want to submit the order?',
    orderItem: null,
    dialog: false,
    notAvailable: ['false', 'N', '0', ''],
    sqSuccess: false,
    sectorID: null,
    currentOrder: null,
  }),
  watch: {
    message(val) {
      return val;
    },
  },
  methods: {
    ...mapAddressActions(['searchAddress', 'getFullAddress']),
    check5GOrder() {
      let order5g = { ...this.params.data };
      order5g.type = '5g';
      const { _sqResponse, sqResult } = order5g;
      if (_sqResponse) {
        let sectorID = sqResult.find((x) => x.name == 'SectorID');
        let fwa_5g = sqResult.find((x) => x.name == '5G_FWA');

        if (
          sectorID &&
          !this.notAvailable.includes(fwa_5g.value.toLowerCase())
        ) {
          this.message = 'Are you sure you want to submit the order?';
          order5g.sectorID = sectorID.value;
          this.sqSuccess = true;
        } else {
          this.sqSuccess = false;
          this.message = '5G activation is not available on this area.';
        }
      } else {
        this.sqSuccess = false;
        this.message = 'Sector ID is missing';
      }
      this.currentOrder = order5g;
      this.dialog = true;
    },
    process5GOrder() {
      if (this.sqSuccess) {
        this.params.clicked(this.currentOrder);
        this.dialog = false;
      } else {
        this.dialog = false;
      }
    },
    setHardwareItem() {
      let hardware = this.params.data;
      hardware.type = 'hardware';
      this.params.clicked(hardware);
    },
    setOrderItem() {
      let order = this.params.data;
      order.type = 'order';
      this.params.clicked(order);
    },
    getServices() {
      let order = this.params.data;
      order.type = 'services';
      this.params.clicked(order);
    },
  },
});
</script>
